import { Wrapper } from "./Divider.styled";

export const Divider = ({ styles }) => <Wrapper addStyles={styles} />;
